/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocio } from '../../conexiones';
import IDivisionesDefectoFiltros from './entidades/divisionesDefectoFiltros';
import IDivisionesDocumentosDefecto from './entidades/divisionesDocumentosDefecto';

export default class ModeloDivisionesDocumentosDefecto {
    public consultarDivisionesDocumentosDefecto() {
        return manejadorRest<IRespuesta<IDivisionesDocumentosDefecto>>(() =>
            negocio.get('DivisionesDocumentosDefecto/ConsultarListaDivisionesDocumentosDefecto')
        );
    }

    public consultaDivisionesPorDefectoCompuestaFiltrada(divisionesDefectoFiltros: IDivisionesDefectoFiltros) {
        return manejadorRest<IRespuesta<IDivisionesDocumentosDefecto>>(
            () =>
                negocio.post(
                    'DivisionesDocumentosDefecto/ConsultaDivisionesDocDefCompuestaFiltrada',
                    divisionesDefectoFiltros
                ),
            true
        );
    }

    public crearDivisionesDocumentosDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        return manejadorRest<IRespuesta<IDivisionesDocumentosDefecto>>(() =>
            negocio.post('DivisionesDocumentosDefecto/GuardarDivisionesDocumentosDefecto', divisionesDocumentosDefecto)
        );
    }

    public editarDivisionesDocumentosDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        return manejadorRest<IRespuesta<IDivisionesDocumentosDefecto>>(() =>
            negocio.put('DivisionesDocumentosDefecto/EditarDivisionesDocumentosDefecto', divisionesDocumentosDefecto)
        );
    }

    public eliminarDivisionesDocumentosDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        return manejadorRest<IRespuesta<IDivisionesDocumentosDefecto>>(() =>
            negocio.delete(
                'DivisionesDocumentosDefecto/EliminarDivisionesDocumentosDefecto',
                divisionesDocumentosDefecto
            )
        );
    }

    public activarDivisionPorDefecto(divisionesDocumentosDefecto: IDivisionesDocumentosDefecto) {
        return manejadorRest<IRespuesta<IDivisionesDocumentosDefecto>>(() =>
            negocio.put('DivisionesDocumentosDefecto/ActivarDivisionPorDefecto', divisionesDocumentosDefecto)
        );
    }
}
